"use client";

import Image from "next/image";
import { useState } from "react";

interface TokenImageProps {
  symbol: string;
  size?: number;
  className?: string;
}

export default function TokenImage({ symbol, size = 96, className = "" }: TokenImageProps) {
  const [fallbackSrc, setFallbackSrc] = useState<string | null>(null);

  return (
    <Image
      src={fallbackSrc || `/token_logos/${symbol.toLowerCase()}.png`}
      width={size}
      height={size}
      alt={`${symbol} Token`}
      className={className}
      onError={() => setFallbackSrc("/token_logos/usdc.png")}
    />
  );
}
